import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["display", "editForm", "inputContainer"];
  static values = {
    successPlaceholder: String,
    generatedPlaceholder: String,
    generateUrl: String,
    regenerateUrl: String
  };

  connect() {
    const token = this.getCookie("hhtk_a4f9c2b1");

    if (token) {
      this.displayTarget.setAttribute("id", "linkedin-plugin-display");
      const button = document.querySelector("#linkedin-plugin-button");
      if (button) button.style.display = "none";

      const regenerateButton = document.querySelector("#linkedin-plugin-regenerate-button");
      if (regenerateButton) regenerateButton.classList.remove("d-none");

      const text = document.querySelector("#linkedin-plugin-text");
      if (text) text.innerHTML = `<i class="fas fa-key me-2"></i> ${this.generatedPlaceholderValue}`;
    }
  }

  async generate(event) {
    if (event) event.preventDefault();
    if (!this.generateUrlValue) return;

    await this.requestToken(this.generateUrlValue);
  }

  async regenerate(event) {
    if (event) event.preventDefault();
    if (!this.regenerateUrlValue) return;

    await this.requestToken(this.regenerateUrlValue);
  }

  async requestToken(url) {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken || "",
          "Accept": "text/html,application/xhtml+xml,application/xml"
        }
      });

      if (!response.ok) return;

      window.location.reload();
    } catch (_error) {
      // Guard against network failures silently
    }
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }
}
